import { route } from "../../service/routeDictionary";
import API from "../../service/api";
import { environment } from "../../environments/env";

const state = {};

const getters = {};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async getRolesByPagination({ commit }, data) {
    if (!(data.name.length > 0)) {
      return await API.get(
        `${environment.apiUri}${route.getPerfilName}?Limit=${data.limit}&Offset=${data.offset}&Sort=+ID`
      );
    } else {
      return await API.get(
        `${environment.apiUri}${route.getPerfilName}?name=${data.name}&Limit=${data.limit}&Offset=${data.offset}&Sort=+ID`
      );
    }
  },
};
const mutations = {};

export default {
  state,
  actions,
  getters,
  mutations,
};
